var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#363A3A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warehouse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 18H18M6 14H18M22 8.35002V20C22 20.5305 21.7893 21.0392 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0392 2 20.5305 2 20V8.35002C2.00161 7.95117 2.12244 7.5619 2.34696 7.23225C2.57149 6.90259 2.88945 6.64759 3.26 6.50002L11.26 3.30002C11.7352 3.11077 12.2648 3.11077 12.74 3.30002L20.74 6.50002C21.1106 6.64759 21.4285 6.90259 21.653 7.23225C21.8776 7.5619 21.9984 7.95117 22 8.35002ZM6 10H18V22H6V10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.64bfcb7ac5943fffc19829cb44eb7571.svg";
export { ForwardRef as ReactComponent };